var StarsComponent = /** @class */ (function () {
    function StarsComponent() {
    }
    return StarsComponent;
}());
export { StarsComponent };
